import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "form-group mb-1 autocomplete-field" }
const _hoisted_2 = ["name", "id", "placeholder", "disabled"]
const _hoisted_3 = {
  key: 0,
  class: "is-invalid"
}
const _hoisted_4 = { class: "is-invalid" }
const _hoisted_5 = ["id"]
const _hoisted_6 = ["onClick", "id"]
const _hoisted_7 = { class: "autocomplete-item__text" }

import {Field, ErrorMessage} from 'vee-validate'
import {AutoCompleteType} from '@/types/AutoCompleteType'
import {ref, Ref, watch} from 'vue'

interface Props {
  elements: Array<AutoCompleteType>
  classes?: string
  fieldName?: string
  placeholder?: string
  idField?: string
  normalizer?: (str: string) => string
  searchHandler?: (term: string) => Promise<Array<AutoCompleteType>>
  debounceMs?: number
  disabled?: boolean
  icon?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AutoComplete',
  props: {
    elements: {},
    classes: {},
    fieldName: {},
    placeholder: {},
    idField: {},
    normalizer: { type: Function },
    searchHandler: { type: Function },
    debounceMs: {},
    disabled: { type: Boolean },
    icon: {}
  },
  emits: ['on-change', 'selected'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const input = ref<HTMLInputElement | null>(null)
const foundElements: Ref<Array<AutoCompleteType>> = ref([])
const searchElement: Ref<string> = ref('')
const selectedIndex = ref(-1)
const emit = __emit
let debounceTimer: number | undefined = undefined

watch(searchElement, (newValue) => {
  if (props.normalizer) searchElement.value = props.normalizer(newValue)
})

watch(foundElements, () => {
  selectedIndex.value = -1
})

watch(() => props.disabled, (disabled) => {
  if (disabled) {
    foundElements.value = []
  }
})

function onChange(): void {
  if (props.disabled) {
    foundElements.value = []
    return
  }
  emit('on-change', searchElement.value)
  
  // Limpiar debounce anterior
  if (debounceTimer) {
    clearTimeout(debounceTimer)
  }
  
  const debounce = props.debounceMs ?? 300
  debounceTimer = window.setTimeout(() => {
    searchElements()
  }, debounce)
}

function searchElements(): void {
  if (props.disabled) {
    foundElements.value = []
    return
  }
  const term = searchElement.value
  if (props.searchHandler) {
    if (term.length <= 2) {
      foundElements.value = []
      return
    }
    const currentTerm = term
    props.searchHandler(term).then((results) => {
      // Evita resultados desfasados si el usuario siguió escribiendo
      if (searchElement.value !== currentTerm) return
      foundElements.value = results.slice(0, 10)
    }).catch(() => {
      foundElements.value = []
    })
    return
  }

  let matches = 0
  if (term.length > 2) {
    foundElements.value = props.elements.filter(element => {
      if (!element.value) return false
      if (element.value.toLowerCase().includes(term.toLowerCase()) && matches < 10) {
        matches++
        return element
      }
    })
  } else {
    foundElements.value = []
  }
}

function selectElement(element: AutoCompleteType): void {
  emit('selected', element, props.idField)
  searchElement.value = element.value
  foundElements.value = []
}

function onKeyDown(event: KeyboardEvent): void {
  const len = foundElements.value.length
  if (len === 0) return

  if (event.code === 'ArrowDown') {
    event.preventDefault()
    selectedIndex.value = (selectedIndex.value + 1) % len
  } else if (event.code === 'ArrowUp') {
    event.preventDefault()
    selectedIndex.value = selectedIndex.value <= 0 ? len - 1 : selectedIndex.value - 1
  } else if (event.code === 'Enter' && selectedIndex.value >= 0) {
    event.preventDefault()
    selectElement(foundElements.value[selectedIndex.value])
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Field), {
      name: props.fieldName ?? '12345',
      ref: input.value,
      modelValue: searchElement.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchElement).value = $event))
    }, {
      default: _withCtx(({ errorMessage, meta }) => [
        _withDirectives(_createElementVNode("input", {
          name: props.fieldName ?? '12345',
          id: __props.idField?? 'search',
          class: _normalizeClass(__props.classes?? 'form-control'),
          type: "text",
          onInput: onChange,
          placeholder: props.placeholder,
          autocomplete: "none",
          onKeydown: onKeyDown,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchElement).value = $event)),
          disabled: props.disabled
        }, null, 42, _hoisted_2), [
          [_vModelText, searchElement.value]
        ]),
        (errorMessage && meta.dirty)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(errorMessage), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name", "modelValue"]),
    _createVNode(_unref(ErrorMessage), {
      name: props.fieldName?? '12345'
    }, {
      default: _withCtx(({ message }) => [
        _createElementVNode("span", _hoisted_4, _toDisplayString(message), 1)
      ]),
      _: 1
    }, 8, ["name"]),
    _withDirectives(_createElementVNode("ul", {
      class: "list-group autocomplete-list",
      id: 'list-' + props.idField + props.fieldName
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(foundElements.value, (element, idx) => {
        return (_openBlock(), _createElementBlock("li", {
          key: element.id,
          onClick: ($event: any) => (selectElement(element)),
          class: _normalizeClass(["list-group-item", { selected: idx === selectedIndex.value }]),
          id: element.id
        }, [
          (props.icon)
            ? (_openBlock(), _createElementBlock("em", {
                key: 0,
                class: _normalizeClass([props.icon, "autocomplete-item__icon"])
              }, null, 2))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_7, _toDisplayString(element.value), 1)
        ], 10, _hoisted_6))
      }), 128))
    ], 8, _hoisted_5), [
      [_vShow, foundElements.value.length > 0]
    ])
  ]))
}
}

})